module.exports = __webpack_public_path__ + "static/media/condor_white.a4deb910.svg";